import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { apiFeedbacksReportsCustomer } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/reports/comment/getData', async datas => {
    const { data } = await apiFeedbacksReportsCustomer(datas)
    return data
})

export const commentSlice = createSlice({
    name: 'admin/reports/comment',
    initialState: {
        loading: true,
        start: moment().startOf('year').locale('en').format('YYYY-MM-DD'),
        end: moment().endOf('year').locale('en').format('YYYY-MM-DD'),
        data: [],
    },
    reducers: {
        setDate: (state, { payload: { start, end } }) => {
            state.start = start
            state.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
                state.data = []
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload
            })
    },
})

export const { setDate } = commentSlice.actions

export default commentSlice.reducer
